// pages/RoleSettings.tsx
import React, { useState} from 'react';

// component
import { Loader } from '../../components/loader/loader';

// formik
import * as yup from 'yup';
import { useFormik } from 'formik';

// redux
import { useDispatch } from 'react-redux';
import { updateUserThunk} from '../../redux/slices/profile.slice'
import { Dispatch } from 'redux';


interface UserProfileFormValues {
    first_name: string;
    last_name: string;
    phone_number: string;
  }

const ProfileSettings: React.FC = () => {
    const dispatch = useDispatch<Dispatch<any>>();
    const [loading, ] = useState(false);
    const [, setSuccessMessage] = useState<string | null>(null);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const UserdetailString = localStorage.getItem("loggedUser") !== 'undefined' ? localStorage.getItem("loggedUser") : undefined
    const Userdetail = UserdetailString ? JSON.parse(UserdetailString) : {};
    const validationSchema = yup.object({
        first_name: yup.string().required('First Name is required'),
        last_name : yup.string().required('Last Name is required'),
        phone_number: yup
                        .string()
                        .required('Mobile Number is required')
                        .matches(/^\d+$/, 'Mobile Number must contain only digits')
                        .min(10, 'Mobile Number must be at least 10 digits')
      });
    
    const formik = useFormik<UserProfileFormValues>({
        initialValues: {
            first_name: Userdetail?.first_name,
            last_name: Userdetail?.last_name,
            phone_number: Userdetail?.phone_number,
        },
        validationSchema,
        onSubmit: async (values) => {
            values.phone_number = String(values.phone_number)
            try {
                await dispatch(updateUserThunk({ params: values })); // Wait for the thunk to complete
                setSuccessMessage('User profile updated successfully');
                setErrorMessage(null);
              } catch (error) {
                setSuccessMessage(null);
                setErrorMessage('An error occurred while updating the profile.');
         
              }
        },
    });

    return (
        <>
            <div className="w-full rounded-lg border border-gray-200  p-4 relative">
                {/* <AccountSettingsTitle title="Profile Settings" description="Updating the Profile Detail">
                </AccountSettingsTitle> */}

                {loading ? (
                    <Loader />
                ) : (
                    <>

                        <form onSubmit={formik.handleSubmit} className="">

                            <div className='flex justify-between items-center mb-4'>
                            <div>
                                <h2 className="text-base font-semibold text-[#202A2B]">Profile Settings</h2>
                                <p className="text-sm text-gray-600">Customize your profile settings.</p>
                            </div>
                            
                            <button
                                type="submit"
                                disabled={formik.isSubmitting}
                                className="px-4 py-2 text-sm font-medium text-white bg-[#17BE62] rounded-lg focus:outline-none focus:ring-4 focus:ring-blue-300 disabled:opacity-50"
                            >
                                {formik.isSubmitting ? 'Updating...' : 'Update'}
                            </button>
                            </div>

                            <hr className="my-4 border-gray-300" />


                        <div className='grid grid-cols-2 gap-4'>
                       
                        <div>
                            <label
                            htmlFor="first_name"
                            className="block text-sm font-medium text-gray-600"
                            >
                            First Name
                            </label>
                            <input
                            type="text"
                            id="first_name"
                            name="first_name"
                            placeholder="Enter first name"
                            value={formik.values.first_name}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            className={`w-full px-4 py-2 mt-2 text-sm text-gray-700 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                                formik.touched.first_name && formik.errors.first_name
                                ? 'border-red-500'
                                : 'border-gray-300'
                            }`}
                            />
                            {formik.touched.first_name && formik.errors.first_name && (
                            <div className="mt-1 text-sm text-red-500">
                                {formik.errors.first_name}
                            </div>
                            )}
                        </div>

                        
                        <div>
                            <label
                            htmlFor="last_name"
                            className="block text-sm font-medium text-gray-600"
                            >
                            Last Name
                            </label>
                            <input
                            type="text"
                            id="last_name"
                            name="last_name"
                            placeholder="Enter last name"
                            value={formik.values.last_name}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            className={`w-full px-4 py-2 mt-2 text-sm text-gray-700 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                                formik.touched.last_name && formik.errors.last_name
                                ? 'border-red-500'
                                : 'border-gray-300'
                            }`}
                            />
                            {formik.touched.last_name && formik.errors.last_name && (
                            <div className="mt-1 text-sm text-red-500">
                                {formik.errors.last_name}
                            </div>
                            )}
                        </div>

                        
                        <div>
                            <label
                            htmlFor="phone_number"
                            className="block text-sm font-medium text-gray-600"
                            >
                            Phone Number
                            </label>
                            <input
                            type="text"
                            id="phone_number"
                            name="phone_number"
                            placeholder="Enter phone number"
                            value={formik.values.phone_number}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            className={`w-full px-4 py-2 mt-2 text-sm text-gray-700 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                                formik.touched.phone_number &&
                                formik.errors.phone_number
                                ? 'border-red-500'
                                : 'border-gray-300'
                            }`}
                            />
                            {formik.touched.phone_number &&
                            formik.errors.phone_number && (
                                <div className="mt-1 text-sm text-red-500">
                                {formik.errors.phone_number}
                                </div>
                            )}
                        </div>

                        </div>
                        </form>
                        {errorMessage && (
                        <p className="mt-4 text-sm text-center text-red-500">
                            {errorMessage}
                        </p>
                        )}



                    </>
                )}
            </div>
        </>
    );
};


export default ProfileSettings;
    